export default {
	NOT_PUBLISHED: 0,
	PUBLISHED: 1,
	PUBLISHING: 2,
	UPDATING: 3,
	AVAILABLE_IN_STORE: 4,
	AVAILABLE_AFTER_PROCESSING: 5,
	DISABLED: 6,
}
